/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

@Injectable()
export class BlobErrorInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.error instanceof Blob && err.error.type.includes('application/json')) {
          return from(err.error.text()).pipe(
            mergeMap((text) => {
              const jsonError = JSON.parse(text);

              // Fehler "umbauen", damit Angular denkt es war JSON
              return throwError(
                () =>
                  new HttpErrorResponse({
                    error: jsonError,
                    headers: err.headers,
                    status: err.status,
                    statusText: err.statusText,
                    url: err.url ?? undefined,
                  }),
              );
            }),
          );
        }

        // 🔹 alle anderen Fehler normal durchreichen
        return throwError(() => err);
      }),
    );
  }
}
